import { render, staticRenderFns } from "./UserFormProfile.vue?vue&type=template&id=157a270c&scoped=true&"
import script from "./UserFormProfile.vue?vue&type=script&lang=js&"
export * from "./UserFormProfile.vue?vue&type=script&lang=js&"
import style0 from "./UserFormProfile.vue?vue&type=style&index=0&id=157a270c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157a270c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('157a270c')) {
      api.createRecord('157a270c', component.options)
    } else {
      api.reload('157a270c', component.options)
    }
    module.hot.accept("./UserFormProfile.vue?vue&type=template&id=157a270c&scoped=true&", function () {
      api.rerender('157a270c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserFormProfile.vue"
export default component.exports